<template>
    <div>
        <Breadcumb title="E-learning" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card class="mb-3 cardcontainer">
            <div class="row">
                <div class="col-2">
                    <img style="width:100%" v-bind:src="require('@/assets/E_Learning_5.svg')"/>
                </div>
                <div class="col-10 pt-5">
                    <h3>Comment concilier engagement collectif et capacité à s’adapter aux imprévus ?</h3>
                    
                    Dans ce module, vous allez  découvrir que le management à distance ne représente ni la fin des échanges, ni celle de la coopération, mais offre  au contraire de
                    nouvelles perspectives pour envisager autrement l’organisation et les modes de travail.<br/><br/>
    
                    De nouvelles pratiques, de nouvelles attentes ou exigences qui interrogent la façon dont vous, en tant que manager, devez envisager votre rôle, votre <strong>posture</strong>
                    et votre <strong>mode de fonctionnement</strong>.
                </div>
            </div>
        </b-card>
        <b-card class="mb-3" style="text-align:center">
            <b-btn variant="primary" target="_blank" href="http://e-learning.echo-obea.fr">Cliquer ici pour accéder à l'espace d'E-learning</b-btn>
        </b-card>
    </div>
</template>

<script>
    import * as numeral from 'numeral'
    import {ADD_COMMENT_REQUEST, GET_FORUMARTICLE_REQUEST} from "../_store/exchange/actiontypes";
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-discussion',
        components: { Breadcumb},
        computed: mapState({ article: state => state.exchange.article}),
        data() {
            return {
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'E-learning', active:true },
                ],
                comment: '',
            }
        },
        methods: {
            addComment: function(e) {
                e.preventDefault()
                this.$store.dispatch(ADD_NEWS_REQUEST, {
                    article: this.$route.params.id,
                    content: this.comment
                })
                    .then(() => {
                        this.$router.push("/echanges/news/");
                        this.$store.dispatch(GET_NEWS_REQUEST);
                        this.comment = '';
                    })
            }
        },
        mounted () {
            this.$store.dispatch(GET_NEWS_REQUEST)
                .then(() => {
                    this.breadcumbData = [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Actualités", active:true}
                    ];
                    console.log(this.breadcumbData)
                })
        }
    }
</script>
